import { toasts } from "../stores.js";
import { API_URL } from "../config.js";

export const getFund = async fundId => {
    let fund_response = await fetch(
        `${API_URL}/fund?fund_id=${fundId}`,
        {
            method: 'GET',
            headers: {
                "Authorization": "Basic womp"
            }
        }
    )
    let json = await fund_response.json()
    return json
}


export const searchFunds = async (title, start, stop) => {
    let fund_response = await fetch(
        `${API_URL}/searchFunds?title=${title}&start=${start}&stop=${stop}`,
        {
            method: 'GET',
            headers: {
                "Authorization": "Basic womp"
            }
        }
    )
    let json = await fund_response.json()
    console.log(json)
    return json
}


export const createFund = async (
    title,
    description,
    email,
    payTo,
    image,
    btcGoal,
    cashStop,
    password,
    endDate
) => {
    const formData = new FormData();

    formData.append("title", title);
    formData.append("description", description);
    formData.append("email", email);
    formData.append("pay_to", payTo);
    formData.append("file", image);
    formData.append("btc_goal", btcGoal);
    formData.append("cash_stop", cashStop);
    formData.append("password", password);
    formData.append("end_date", endDate);

    let fund_response = await fetch(
        `${API_URL}/newFund`,
        {
            method: 'POST',
            headers: {
                "Authorization": "Basic womp"
            },
            body: formData
        }
    )
    return fund_response
}

export const verifyFund = async (fundId, verificationCode) => {
    let response = await fetch(
        `${API_URL}/verifyFund?fund_id=${params.fund_id}&code=${params.code}`,
        {
            method: "POST",
            headers: {
                "Authorization": "Basic womp"
            }
        }
    );

    return (response.status == 200);
}
